'use client';

import { useMemo } from 'react';

import * as styles from './BannerTopsort.css';

const BANNER_SIZES = {
  desktop: { width: 1110, height: 300 },
  mobile: { width: 640, height: 340 },
};

export default function BannerTopsort({
  idBanner,
  isMobile = true,
}: {
  idBanner: string;
  isMobile?: boolean;
}) {
  const size = useMemo(() => (!isMobile ? BANNER_SIZES?.desktop : BANNER_SIZES.mobile), [isMobile]);

  return (
    <div className={styles.ContainerBase}>
      <topsort-banner {...size} id={idBanner} />
    </div>
  );
}
